import { useState } from "react";
import { faqs } from "@/mocks/editorial";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="section-pad scroll-mt-20 bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="container-x grid gap-10 lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="观影指南"
            title="关于吃瓜影院，你或许想问"
            desc="从网站定位到如何正规观影、如何投稿反馈，我们把常见问题一次讲清楚。"
          />
          <div className="mt-8 flex items-center gap-5 rounded-2xl border border-background-200 bg-background-100 p-5">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-customer-service-2-line text-2xl" aria-hidden="true"></i>
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">还有别的疑问？</p>
              <p className="mt-0.5 text-sm text-foreground-600">欢迎通过“联系我们”向编辑部留言，我们会尽快回复你。</p>
            </div>
            <a
              href="#contact"
              className="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full bg-primary-600 px-4 py-2 text-sm font-semibold text-white hover:bg-primary-700"
            >
              联系我们
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center gap-3 px-5 py-4 text-left"
                >
                  <span
                    className={
                      "flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold " +
                      (isOpen ? "bg-accent-500 text-foreground-950" : "bg-secondary-100 text-secondary-900")
                    }
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="flex-1 text-sm font-semibold text-foreground-950 md:text-base">{item.q}</h3>
                  <i
                    className={
                      "text-xl text-foreground-500 transition-transform duration-300 " +
                      (isOpen ? "ri-subtract-line rotate-180" : "ri-add-line")
                    }
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className={
                    "grid transition-[grid-template-rows] duration-300 " +
                    (isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]")
                  }
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-[60px] text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}